import request from "utils/request";

const homeApi = async () => {
    return await request.get(`/tour/home`);
};

export {
    homeApi
};
